var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabbarHelpSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6418_1291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.96094 19.9219C15.4102 19.9219 19.9219 15.4004 19.9219 9.96094C19.9219 4.51172 15.4004 0 9.95117 0C4.51172 0 0 4.51172 0 9.96094C0 15.4004 4.52148 19.9219 9.96094 19.9219ZM9.75586 12.0508C9.23828 12.0508 8.94531 11.7773 8.94531 11.25C8.94531 11.2109 8.94531 11.1621 8.94531 11.123C8.94531 10.127 9.49219 9.59961 10.2148 9.0918C11.0938 8.47656 11.5137 8.14453 11.5137 7.46094C11.5137 6.69922 10.918 6.18164 10.0098 6.18164C9.33594 6.18164 8.81836 6.51367 8.45703 7.09961L8.28125 7.34375C8.0957 7.57812 7.87109 7.74414 7.5293 7.74414C7.19727 7.74414 6.83594 7.5 6.83594 7.05078C6.83594 6.875 6.875 6.70898 6.92383 6.55273C7.19727 5.625 8.33008 4.81445 10.0684 4.81445C11.7871 4.81445 13.2812 5.70312 13.2812 7.38281C13.2812 8.59375 12.5781 9.17969 11.6016 9.82422C10.8984 10.2832 10.5762 10.6445 10.5762 11.2109C10.5762 11.2402 10.5762 11.2891 10.5762 11.3281C10.5762 11.7285 10.2637 12.0508 9.75586 12.0508ZM9.73633 15.0488C9.15039 15.0488 8.64258 14.5801 8.64258 14.0039C8.64258 13.4277 9.14062 12.9492 9.73633 12.9492C10.332 12.9492 10.8301 13.418 10.8301 14.0039C10.8301 14.5898 10.3223 15.0488 9.73633 15.0488Z",
    fill: "#1D1E2C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6418_1291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9219,
    height: 19.9316,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabbarHelpSelected);
export default __webpack_public_path__ + "static/media/tabbar-help-selected.c6aef6696b40a87ca816dc25b91e4618.svg";
export { ForwardRef as ReactComponent };